module.exports = __webpack_public_path__ + "2c6c54ef0eb896d36a459a3a74c75c45.svg";